module.exports = __webpack_public_path__ + "static/media/Logo-puw.87803ea2.png";